<template>
    <body>
        <!-- <img
            src="/img/01_background_img.png"
            style="height:1000px;width:100%;float:left"
        /> -->
        <div class='error_box' v-if='isActive'>
            <div class='eb'>
                <p class='error'>認証エラー</p>
                <p>認証コードが正しくありません．入力し直してください！</p>
                <input type="button" value="close" class='close_btn btn-red' v-on:click="isActive=false">
            </div>
        </div>
        <div id=login>
            <img
                src="/img/04_JVTA_Online_logo_B.svg"
                alt="logo_menu"
                class="logo"
                style="width: 200px;"
            />
            <div id=login_box>
                <form action="" method="post" class="two_auth" onsubmit="return false;">
                    <dl>
                        <p style="font-weight:500;">認証コードを入力してください．</p>
                        <div class="lf_code">
                            <dt><label for="code">Code</label></dt>
                            <dd><input type="text" name="code" v-model="form.code" placeholder="code" id="code"></dd>
                        </div>
                        <div class='fp'><a href="#">リカバリーコードを発行する</a></div>
                        <div class="lf_submit">
                            <input type="submit" value="Login" v-on:click="popuperror" id="sb" class="btn-purple">
                        </div>
                    </dl>
                </form>
            </div>
        </div>
    </body>
</template>

<style lang="css">
    *{
        padding:0;
        margin: 0;
    }
    /* html,body{
        overflow: hidden;
    } */
    .fp{
        text-align: center;
    }
    .fp a{
        opacity: 0.5;
        color: black;
    }
    input::placeholder {
        text-align: center;
    }
    #code{
        width: 280px;
    }
    #sb{
        width: 280px;
        /* font-weight: 700; */
        margin: 15px 0;
    }
    .close_btn{
        float:right;
        margin:10px;
        width:70px;
    }
    .error_box{
        position: fixed;
        z-index: 10;
        width: 100%;
        height: 100%;
        background: rgba(1, 1, 1, 0.3);
    }
    .eb{
        border: solid black ;
        background: #FFFBF9;
        width:350px;
        height: 150px;
        position: absolute;
        top: 5%;
        left: 50%;
        transform: translate(-50%);
    }
    .eb p{
        margin: 0;
        padding:10px;
        font-size: small;
        font-weight: 300;
    }
    .error{
        background: #D20000;
        color: white;
    }
    .active{
        display: block;
    }
    .lf_rm{
        position: relative;
    }
    .lf_submit{
        float: right;
    }
    .logo{
        display: block;
        margin: 0 auto;
    }
    body{
        background-image: url("/img/01_background_img.png");
        /* 画像を常に天地左右の中央に配置 */
        background-position: center center;
        /* 画像をタイル状に繰り返し表示しない */
        background-repeat: no-repeat;
        /* コンテンツの高さが画像の高さより大きい時、動かないように固定 */
        background-attachment: fixed;
        /* 表示するコンテナの大きさに基づいて、背景画像を調整 */
        background-size: cover;
        /* 背景画像が読み込まれる前に表示される背景のカラー */
        background-color: #464646;
    }
    #login{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    #login_box{
        /* background: #A07ABE; */
        padding: 12px 10px 10px 10px;
        width:300px;
        height: 200px;
        /* border: solid black 1px; */
    }
</style>

<script>
    import { defineComponent } from 'vue';
    import { Head } from '@inertiajs/inertia-vue3';
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'

    export default defineComponent({
        components: {
            Head,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors,
        },

        data() {
            return {
                recovery: false,
                form: this.$inertia.form({
                    code: '',
                    recovery_code: '',
                })
            }
        },

        methods: {
            toggleRecovery() {
                this.recovery ^= true

                this.$nextTick(() => {
                    if (this.recovery) {
                        this.$refs.recovery_code.focus()
                        this.form.code = '';
                    } else {
                        this.$refs.code.focus()
                        this.form.recovery_code = ''
                    }
                })
            },

            popuperror() {
                this.form.post(this.route('two-factor.login'))
            }
        }
    })
</script>